module.exports = __webpack_public_path__ + "img/20200215162227360截图20200215161147964.cda30efe.jpg";